const API_URL = process.env.VUE_APP_API_URL;

function getToken() {
  const AUTH_TOKEN = localStorage.getItem("authToken");
  return AUTH_TOKEN;
}

export default {
  apiUrl: API_URL,
  getToken,
};
